<template>
  <v-container grid-list-xl fluid>
    <v-container class="ma-0 pa-0" fluid>
      <v-container grid-list-xs fluid style="padding: 0px">
        <v-layout row style="padding: 0px">
          <v-flex md6>
            <v-text-field
              ref="form"
              class="mr-1"
              prepend-icon="search"
              label="Search By Control No."
              v-model="searchItem"
              clearable
              hide-details
            ></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-btn fab dark small color="amber darken-2" @click="playData()">
            <v-icon dark>play_arrow</v-icon>
          </v-btn>

          <v-tooltip top>
            <v-btn
              fab
              dark
              small
              color="amber darken-2"
              slot="activator"
              @click="refreshData()"
            >
              <v-icon>refresh</v-icon>
            </v-btn>
            <span>Refresh</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              fab
              dark
              small
              color="amber darken-2"
              slot="activator"
              @click="downloadExcel()"
            >
              <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                <path
                  fill="#ffffff"
                  d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z"
                />
              </svg>
            </v-btn>
            <span>Download Excel File</span>
          </v-tooltip>
        </v-layout>

        <v-container grid-list-lg fluid style="padding: 0px" class="mt-3">
          <v-layout>
            <v-flex md2 style="padding: 0 5px">
              <v-menu
                ref="menu"
                :close-on-content-click="false"
                v-model="menu"
                :nudge-right="40"
                lazy
                :disabled="queryParams.search ? true : false"
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  :disabled="queryParams.search ? true : false"
                  v-model="dateFrom"
                  label="Date From"
                  prepend-inner-icon="event"
                  outline
                  readonly
                ></v-text-field>
                <v-date-picker
                  ref="picker"
                  v-model="dateFrom"
                  :max="dateTo"
                  min="1950-01-01"
                  @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <!-- 
            <v-flex md2 style="padding: 0 5px">
              <v-menu
                ref="timeFromMenu"
                :close-on-content-click="false"
                v-model="timeFromMenu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="timeFrom"
                  @click="clockMode = 'timeFrom'"
                  label="Time From"
                  prepend-inner-icon="event"
                  outline
                  readonly
                ></v-text-field>

                <v-time-picker v-model="timeFrom" format="24hr">
                  <v-btn flat color="amber" @click="cancelTimePicker"
                    >Cancel</v-btn
                  >
                  <v-spacer></v-spacer>
                  <v-btn flat color="amber" @click="timeFromMenu = false"
                    >DONE</v-btn
                  >
                </v-time-picker>
              </v-menu>
            </v-flex>-->

            <v-flex md2 style="padding: 0 5px">
              <v-menu
                ref="menu1"
                :close-on-content-click="false"
                v-model="menu1"
                :nudge-right="40"
                lazy
                :disabled="queryParams.search ? true : false"
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  :disabled="queryParams.search ? true : false"
                  v-model="dateTo"
                  label="Date To"
                  prepend-inner-icon="event"
                  outline
                  readonly
                ></v-text-field>
                <v-date-picker
                  ref="picker"
                  v-model="dateTo"
                  :max="new Date().toISOString().substr(0, 10)"
                  :min="dateFrom"
                  @input="menu1 = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <!-- 
            <v-flex md2 style="padding: 0 5px">
              <v-menu
                ref="timeToMenu"
                :close-on-content-click="false"
                v-model="timeToMenu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="timeTo"
                  @click="clockMode = 'timeTo'"
                  label="Time To"
                  prepend-inner-icon="event"
                  outline
                  readonly
                ></v-text-field>
                <v-time-picker v-model="timeTo" format="24hr">
                  <v-btn flat color="amber" @click="cancelTimePicker"
                    >Cancel</v-btn
                  >
                  <v-spacer></v-spacer>
                  <v-btn flat color="amber" @click="timeToMenu = false"
                    >DONE</v-btn
                  >
                </v-time-picker>
              </v-menu>
            </v-flex>-->
          </v-layout>
        </v-container>
      </v-container>

      <bottom-scroll @on-bottom="loadMore" :offset="queryParams.offset">
        <v-data-table
          :headers="headers"
          :items="items"
          hide-actions
          disable-initial-sort
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  header.value === queryParams.order ? 'active' : '',
                  'text-xs-' + header.align,
                ]"
              >
                <span>{{ header.text }}</span>
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
          <tr>
            <td class="text-xs-center">{{ props.index + 1 }}</td>
            <td class="text-xs-left">
              <v-tooltip top>
                <v-btn
                  icon
                  small
                  style="height: 16px; width: 15px"
                  slot="activator"
                  @click="
                    viewTransactions(props.item.id);
                    totals(props.item);
                    dialogue = true;
                  "
                >
                  <v-icon color="blue">find_in_page</v-icon>
                </v-btn>
                <span>View Transactions Summary</span>
              </v-tooltip>
            </td>
            <td class="text-xs-left text-uppercase">
              {{ props.item.sub_company ? props.item.sub_company: "--" }}
            </td>
            <td class="text-xs-left text-no-wrap">
              {{ props.item.control_no }}
            </td>
            <td class="text-xs-left">
              {{ props.item.device_serial ? props.item.device_serial : "--" }}
            </td>
            <td class="text-xs-left text-uppercase text-no-wrap">
              {{ props.item.terminal ? props.item.terminal : "--" }}
            </td>
            <td class="text-xs-center text-uppercase text-no-wrap">
              {{
                props.item.opening_shift_datetime === null
                  ? "--"
                  : $dateFormat(props.item.opening_shift_datetime, "YYYY-MM-DD")
              }}
            </td>
            <td class="text-xs-center text-uppercase">
              {{
                props.item.opening_shift_datetime === null
                  ? "--"
                  : $dateFormat(props.item.opening_shift_datetime, "HH:mm")
              }}
            </td>
            <td class="text-xs-center text-uppercase text-no-wrap">
              {{
                props.item.closing_shift_datetime === null
                  ? "--"
                  : $dateFormat(props.item.closing_shift_datetime, "YYYY-MM-DD")
              }}
            </td>
            <td class="text-xs-center text-uppercase">
              {{
                props.item.closing_shift_datetime === null
                  ? "--"
                  : $dateFormat(props.item.closing_shift_datetime, "HH:mm")
              }}
            </td>
            <td class="text-xs-left text-uppercase">
              {{
                props.item.opening_transaction_no === null
                  ? "--"
                  : props.item.opening_transaction_no === ""
                  ? "--"
                  : props.item.opening_transaction_no === "null"
                  ? "--"
                  : props.item.opening_transaction_no
              }}
            </td>
            <td class="text-xs-left text-uppercase">
              {{
                props.item.closing_transaction_no === null
                  ? "--"
                  : props.item.closing_transaction_no === ""
                  ? "--"
                  : props.item.closing_transaction_no === "null"
                  ? "--"
                  : props.item.closing_transaction_no
              }}
            </td>
            <td class="text-xs-right">{{ props.item.reload_count }}</td>
            <td class="text-xs-right">
              {{ $amountInPeso(props.item.reload_gross ? props.item.reload_gross : 0 ) }}
            </td>
            <td class="text-xs-right">{{ props.item.sold_count }}</td>
            <td class="text-xs-right">
              {{ $amountInPeso(props.item.sold_gross ? props.item.sold_gross : 0) }}
            </td>
            <td class="text-xs-right">{{ props.item.credit_sold_count }}</td>
            <td class="text-xs-right">
              {{ $amountInPeso(props.item.credit_sold_gross ? props.item.credit_sold_gross : 0) }}
            </td>
            <td class="text-xs-right">{{ props.item.credit_redeem_count }}</td>
            <td class="text-xs-right">{{ props.item.balance_count }}</td>
            <td class="text-xs-right">{{ props.item.credit_count }}</td>
            <td class="text-xs-right">
              {{ $amountInPeso(props.item.credit_gross ? props.item.credit_gross : 0) }}
            </td>
            <td class="text-xs-right">{{ props.item.transfer_count }}</td>
            <td class="text-xs-right" style="text-align: right !important;">
              {{ $amountInPeso(props.item.transfer_fee_card ? props.item.transfer_fee_card : 0) }}
            </td>
            <td class="text-xs-right">
              {{ $amountInPeso(props.item.transfer_fee_cash ? props.item.transfer_fee_cash: 0) }}
            </td>
            <td class="text-xs-right">
              {{ $amountInPeso(props.item.transfer_fee_gross ? props.item.transfer_fee_gross : 0) }}
            </td>
            <td class="text-xs-right">
              {{  $amountInPeso(props.item.gross_revenue ? props.item.gross_revenue : 0) }}
            </td>
            <td class="text-xs-right">
              {{
                props.item.reload_count +
                  props.item.sold_count +
                  props.item.credit_count +
                  props.item.credit_sold_count +
                  props.item.credit_redeem_count +
                  props.item.balance_count +
                  props.item.transfer_count
              }}
            </td>

            <td class="text-xs-left text-uppercase text-no-wrap">
              {{ `${props.item.first_name
                  ? props.item.first_name
                  : ""
                } ${props.item.last_name ? 
                  props.item.last_name : ""
                }` }}
            </td>
            <td class="text-xs-left text-uppercase">
              {{
                props.item.opening_lat === null &&
                props.item.opening_long === null
                  ? "--,--"
                  : props.item.opening_lat === "" &&
                    props.item.opening_long === ""
                  ? "--,--"
                  : props.item.opening_lat === "null" &&
                    props.item.opening_long === "null"
                  ? "--,--"
                  : props.item.opening_lat + "," + props.item.opening_long
              }}
            </td>
            <td class="text-xs-left text-uppercase">
              {{
                props.item.closing_lat === null &&
                props.item.closing_long === null
                  ? "--,--"
                  : props.item.closing_lat === "" &&
                    props.item.closing_long === ""
                  ? "--,--"
                  : props.item.closing_lat === "null" &&
                    props.item.closing_long === "null"
                  ? "--,--"
                  : props.item.closing_lat + "," + props.item.closing_long
              }}
            </td>
          </tr>
          </template>
        </v-data-table>
      </bottom-scroll>
      <v-divider></v-divider>

      <!-- View Transaction Summary Dialogue -->
      <v-dialog
        v-model="dialogue"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        @keydown.esc="dialogue = false"
      >
        <v-card>
          <v-toolbar dark color="blue">
            <v-card-title class="headline"
              >View Transactions Summary</v-card-title
            >
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                icon
                dark
                color="blue"
                slot="activator"
                @click="downloadExcelTransactionReport"
              >
                <v-icon>file_download</v-icon>
              </v-btn>

              <v-btn icon dark @click="dialogue = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-container fill-height v-if="dialogLoader === true">
            <v-layout align-center justify-center>
              <v-progress-circular
                :size="40"
                :width="3"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </v-layout>
          </v-container>
          <v-container fluid v-if="dialogLoader === false">
            <transaction-summary
              :dialogLoader="dialogLoader"
              :dialogue="dialogue"
              :reloadCount="reloadCount"
              :soldCount="soldCount"
              :balanceCount="balanceCount"
              :creditCount="creditCount"
              :creditGross="creditGross"
              :soldGross="soldGross"
              :soldCreditCount="soldCreditCount"
              :soldCreditGross="soldCreditGross"
              :creditRedeemCount="creditRedeemCount"
              :reloadGross="reloadGross"
              :transferCount="transferCount"
              :transferFeeCard="transferFeeCard"
              :transferFeeCash="transferFeeCash"
              :transferFeeGross="transferFeeGross"
              :grossRevenue="grossRevenue"
            ></transaction-summary>
            <transaction-summary-list
              :dialogLoader="dialogLoader"
              :headers2="headers2"
              :items2="items2"
              :queryParams="queryParams"
            ></transaction-summary-list>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-container>
</template>

<script>
import Services from "@/services/Services";
import TransactionSummary from "@/components/tripko/TransactionTable/TransactionSummary.vue";
import TransactionSummaryList from "@/components/tripko/TransactionTable/TransactionSummaryList.vue";
import XLSX from "xlsx";
var now = new Date();

export default {
  components: {
    TransactionSummary,
    TransactionSummaryList,
  },
  data() {
    return {
      clockMode: "",
      dateFromMenu: false,
      dateToMenu: false,
      timeFromMenu: false,
      timeToMenu: false,
      timeFrom: "00:00",
      timeTo: "23:59",
      fixedHeader: false,
      height: 300,
      timeOut: null,
      dialogLoader: false,
      grossRevenue: 0,
      soldCount: 0,
      soldGross: 0,
      soldCreditCount: 0,
      soldCreditGross: 0,
      creditRedeemCount: 0,
      balanceCount: 0,
      creditCount: 0,
      creditGross: 0,
      reloadCount: 0,
      reloadGross: 0,
      transferCount: 0,
      transferFeeCard: 0,
      transferFeeCash: 0,
      transferFeeGross: 0,
      openPanel: [true],
      items: [],
      headers2: [
        { text: "#", align: "center", sortable: false },
        {
          text: "Trx No.",
          align: "center",
          value: "transaction_no",
          sortable: false,
        },
        {
          text: "Card No.",
          align: "center",
          value: "card_no",
          sortable: false,
        },
        {
          text: "Time",
          align: "center",
          value: "time",
          sortable: false,
        },
        {
          text: "Type",
          align: "center",
          value: "type",
          sortable: false,
        },
        {
          text: "Remaining Balance",
          align: "right",
          value: "remaining_balance",
          sortable: false,
        },
        {
          text: "Card Amount",
          align: "right",
          value: "amount",
          sortable: false,
        },
      ],
      items2: [],
      dialogue: false,
      dialogueTotals: false,
      title: "Shift Wireless",
      headers: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "",
          align: "left",
          value: "",
          sortable: false,
        },
        {
          text: "Merchant Code",
          align: "left",
          value: "merchant",
          sortable: false,
        },
        {
          text: "Control No.",
          align: "left",
          value: "control_no",
          sortable: false,
        },
        {
          text: "Device Code",
          align: "left",
          value: "device_serial",
          sortable: false,
        },
        {
          text: "Branch",
          align: "left",
          value: "branch",
          sortable: false,
        },
        {
          text: "Opening Date",
          align: "center",
          value: "opening_date",
          sortable: false,
        },
        {
          text: "Opening Time",
          align: "center",
          value: "opening_time",
          sortable: false,
        },
        {
          text: "End Date",
          align: "center",
          value: "end_date",
          sortable: false,
        },
        {
          text: "End Time",
          align: "center",
          value: "end_time",
          sortable: false,
        },
        {
          text: "Opening Trx#",
          align: "left",
          value: "opening_trx#",
          sortable: false,
        },
        {
          text: "Closing Trx#",
          align: "left",
          value: "closing_trx#",
          sortable: false,
        },
        {
          text: "Reload Count",
          align: "right",
          value: "reload_count",
          sortable: false,
        },
        {
          text: "Reload Gross",
          align: "right",
          value: "reload_gross",
          sortable: false,
        },
        {
          text: "Sold Count",
          align: "right",
          value: "sold_count",
          sortable: false,
        },
        {
          text: "Sold Gross",
          align: "right",
          value: "sold_gross",
          sortable: false,
        },
        {
          text: "Sold Credit Count",
          align: "right",
          value: "sold_credit_count",
          sortable: false,
        },
        {
          text: "Sold Credit Gross",
          align: "right",
          value: "sold_credit_gross",
          sortable: false,
        },
        {
          text: "Credit Redeem Count",
          align: "right",
          value: "credit_redeem_count",
          sortable: false,
        },
        {
          text: "Balance Count",
          align: "right",
          value: "balance_count",
          sortable: false,
        },
        {
          text: "Credit Count",
          align: "right",
          value: "credit_count",
          sortable: false,
        },
        {
          text: "Credit Gross",
          align: "right",
          value: "credit_gross",
          sortable: false,
        },
        {
          text: "Transfer Count",
          align: "right",
          value: "transfer_count",
          sortable: false,
        },
        {
          text: "Transfer Fee Card",
          align: "right",
          value: "transfer_fee_card",
          sortable: false,
        },
        {
          text: "Transfer Fee Cash",
          align: "right",
          value: "transfer_fee_cash",
          sortable: false,
        },
        {
          text: "Transfer Fee Gross",
          align: "right",
          value: "transfer_fee_gross",
          sortable: false,
        },
        {
          text: "Total Gross",
          align: "right",
          value: "total_gross",
          sortable: false,
        },
        {
          text: "Total Count",
          align: "right",
          value: "total_count",
          sortable: false,
        },
        {
          text: "Cashier Name",
          align: "left",
          value: "cashier_name",
          sortable: false,
        },
        {
          text: "Opening Location",
          align: "left",
          value: "lat",
          sortable: false,
        },
        {
          text: "Closing Location",
          align: "left",
          value: "long",
          sortable: false,
        },
      ],
      queryParams: {
        search: null,
        offset: 0,
        limit: 100,
        date_from: null,
        date_to: null,
      },
      totalItems: 0,
      menu: false,
      menu1: false,
      date_from: this.$dateFormat(now, "YYYY-MM-DD"),
      date_to: this.$dateFormat(now, "YYYY-MM-DD"),
      play_status: false,
    };
  },
  created: async function() {
    await this.$store.commit("initiateTempData");
    this.resetTable();
    // await this.getData(true);
  },
  beforeDestroy() {
    window.stop();
  },
  computed: {
    computedItems() {
      return this.$store.state.tempData;
    },
    searchItem: {
      get() {},
      set(value) {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
          this.search(value);
        }, 500);
      },
    },
    dateFrom: {
      get() {
        this.queryParams.date_from = this.date_from;
        this.queryParams.date_from = this.queryParams.date_from + " 00:00:00";
        return this.date_from;
      },
      set(value) {
        this.resetTable();
        this.queryParams.date_from = value;
        this.queryParams.date_from = this.queryParams.date_from + " 00:00:00";
        this.date_from = value;
      },
    },
    dateTo: {
      get() {
        this.queryParams.date_to = this.date_to;
        this.queryParams.date_to = this.queryParams.date_to + " 23:59:59";
        return this.date_to;
      },
      set(value) {
        this.resetTable();
        this.queryParams.date_to = value;
        this.date_to = value;
      },
    },
  },
  methods: {
    search(data) {
      this.resetTable();
      this.queryParams.search = data;

      this.queryParams.date_from = data ? null : this.date_from;
      this.queryParams.date_to = data ? null : this.date_to;
    },
    async getData() {
      this.$store.dispatch("startLoading");

      try {
        const response = (await Services.getShiftWireless(this.queryParams))
          .data;

        // Assign the reponse data to items to be display on table
        this.items = this.items.concat(response.data.shifts);

        this.totalItems = response.data.count;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network connection",
          });
        }
      }

      this.$store.dispatch("endLoading");
    },
    async viewTransactions(data) {
      this.dialogLoader = true;
      let dataView = (await Services.getShiftWirelessView(data)).data;
      this.items2 = dataView.data;
      setTimeout(() => {
        this.dialogLoader = false;
      }, 600);
    },
    async totals(data) {
      this.reloadCount = data.reload_count;
      this.reloadGross = data.reload_gross ? data.reload_gross : 0;
      this.soldCount = data.sold_count;
      this.soldGross = data.sold_gross ? data.sold_gross : 0;
      this.soldCreditCount = data.credit_sold_count ? data.credit_sold_count : 0;
      this.soldCreditGross = data.credit_sold_gross ? data.credit_sold_gross : 0;
      this.creditRedeemCount = data.credit_redeem_count;
      this.balanceCount = data.balance_count;
      this.creditCount = data.credit_count;
      this.transferCount = data.transfer_count;
      this.transferFeeCard = data.transfer_fee_card ? data.transfer_fee_card : 0;
      this.transferFeeCash = data.transfer_fee_cash ? data.transfer_fee_cash : 0;
      this.transferFeeGross = data.transfer_fee_gross ? data.transfer_fee_gross : 0;
      this.creditGross = data.credit_gross ? data.credit_gross : 0;
      this.grossRevenue = data.gross_revenue ? data.gross_revenue : 0;
    },
    async playData() {
      this.items = [];

      this.resetTable();

      // this.$refs.form.reset();

      this.play_status = true;
      this.getData();
    },
    refreshData() {
      this.date_from = this.$dateFormat(now, "YYYY-MM-DD");
      this.date_to = this.$dateFormat(now, "YYYY-MM-DD");
      this.$refs.form.reset();
      this.items = [];

      this.resetTable();
    },
    resetTable() {
      this.queryParams.limit = 100;
      this.queryParams.offset = 0;

      this.play_status = false;
    },
    async loadMore() {
      if (!this.play_status) return;

      this.queryParams.offset += this.queryParams.limit;

      if (this.queryParams.offset >= this.totalItems) return;

      await this.getData();
    },
    cancelTimePicker() {
      if (this.clockMode === "timeFrom") {
        this.timeFrom = "00:00";
        this.timeFromMenu = false;
      }
      if (this.clockMode === "timeTo") {
        this.timeTo = "23:59";
        this.timeToMenu = false;
      }
    },
    async downloadExcelTransactionReport() {
      let dataToDownload = [];
      let header = [];

      for (let i = 0; i < this.headers2.length; i++) {
        header.push(this.headers2[i].text);
      }

      header.splice(0, 1);

      dataToDownload.push(header);

      for (let e = 0; e < this.items2.length; e++) {
        let theItem = [];

        theItem.push(this.items2[e].transaction_no),
          theItem.push(this.items2[e].card_no),
          theItem.push(
            this.$dateFormat(this.items2[e].transaction_date, "HH:mm")
          ),
          theItem.push(this.items2[e].transaction_type.name.toUpperCase()),
          theItem.push(this.items2[e].remaining_balance),
          theItem.push(this.items2[e].card_amount);

        dataToDownload.push(theItem);
      }

      var wscols = [
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
      ];

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      // var wsname = "SheetJS";

      var fmt = "#,##0";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }
      // wb.SheetNames.push(wsname);
      // wb.Sheets[wsname] = ws;
      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports",
      };

      // ws["!protect"] = {
      //   password: "Journeytech@1",
      //   formatRows: false,
      //   formatColumns: false,
      //   objects: true,
      //   scenarios: true
      // };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"],
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf",
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null,
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    },
    async downloadExcel() {
      this.$store.dispatch("startLoading");

      // this.items = [];

      const response2 = (
        await Services.getShiftWireless({
          offset: 0,
          search: this.queryParams.search,
          date_from: this.queryParams.date_from,
          date_to: this.queryParams.date_to,
        })
      ).data;

      const items = response2.data.shifts;

      let dataToDownload = [];
      let header = [];

      for (let i = 0; i < this.headers.length; i++) {
        header.push(this.headers[i].text);
      }

      header.splice(0, 2);

      dataToDownload.push(header);

      for (let e = 0; e < items.length; e++) {
        let theItem = [];

        theItem.push(items[e].sub_company ? items[e].sub_company : "--");
        theItem.push(items[e].control_no);
        theItem.push(items[e].device_serial ? items[e].device_serial : "--");
        theItem.push(items[e].terminal ? items[e].terminal : "--");
        theItem.push(
          this.$dateFormat(items[e].opening_shift_datetime, "YYYY-MM-DD")
        );
        theItem.push(
          this.$dateFormat(items[e].opening_shift_datetime, "HH:mm")
        );
        theItem.push(
          items[e].closing_shift_datetime === null
            ? "--"
            : items[e].closing_shift_datetime === ""
            ? "--"
            : items[e].closing_shift_datetime === "null"
            ? "--"
            : this.$dateFormat(items[e].closing_shift_datetime, "YYYY-MM-DD")
        );
        theItem.push(
          items[e].closing_shift_datetime === null
            ? "--"
            : items[e].closing_shift_datetime === ""
            ? "--"
            : items[e].closing_shift_datetime === "null"
            ? "--"
            : this.$dateFormat(items[e].closing_shift_datetime, "HH:mm")
        );
        theItem.push(
          items[e].opening_transaction_no === null
            ? "--"
            : items[e].opening_transaction_no === ""
            ? "--"
            : items[e].opening_transaction_no === "null"
            ? "--"
            : "'" + items[e].opening_transaction_no
        );
        theItem.push(
          items[e].closing_transaction_no === null
            ? "--"
            : items[e].closing_transaction_no === ""
            ? "--"
            : items[e].closing_transaction_no === "null"
            ? "--"
            : "'" + items[e].closing_transaction_no
        );
        theItem.push(items[e].reload_count);
        theItem.push(items[e].reload_gross);
        theItem.push(items[e].sold_count);
        theItem.push(items[e].sold_gross);
        theItem.push(items[e].credit_sold_count);
        theItem.push(items[e].credit_sold_gross);
        theItem.push(items[e].credit_redeem_count);
        theItem.push(items[e].balance_count);
        theItem.push(items[e].credit_count);
        theItem.push(items[e].credit_gross);
        theItem.push(items[e].transfer_count);
        theItem.push(items[e].transfer_fee_card);
        theItem.push(items[e].transfer_fee_cash);
        theItem.push(items[e].transfer_fee_gross);
        theItem.push(items[e].gross_revenue);
        theItem.push(
          items[e].reload_count +
            items[e].sold_count +
            items[e].credit_count +
            items[e].credit_sold_count +
            items[e].credit_redeem_count +
            items[e].balance_count +
            items[e].transfer_count
        );
        theItem.push(
          `${
            items[e].first_name
              ? items[e].first_name.toUpperCase()
              : ""
          } ${
            items[e].last_name
              ? items[e].last_name.toUpperCase()
              : ""
          }`
        );
        theItem.push(
          items[e].opening_lat === null && items[e].opening_long === null
            ? "--,--"
            : items[e].opening_lat === "" && items[e].opening_long === ""
            ? "--,--"
            : items[e].opening_lat === "null" &&
              items[e].opening_long === "null"
            ? "--,--"
            : items[e].opening_lat + "," + items[e].opening_long
        );
        theItem.push(
          items[e].closing_lat === null && items[e].closing_long === null
            ? "--,--"
            : items[e].closing_lat === "" && items[e].closing_long === ""
            ? "--,--"
            : items[e].closing_lat === "null" &&
              items[e].closing_long === "null"
            ? "--,--"
            : items[e].closing_lat + "," + items[e].closing_long
        );

        dataToDownload.push(theItem);
      }

      this.$store.dispatch("endLoading");

      // don't delete any codes after this comment got it?!

      var wscols = [
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
      ];

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      // var wsname = "SheetJS";

      var fmt = "#,##0";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }
      // wb.SheetNames.push(wsname);
      // wb.Sheets[wsname] = ws;
      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports",
      };

      // ws["!protect"] = {
      //   password: "Journeytech@1",
      //   formatRows: false,
      //   formatColumns: false,
      //   objects: true,
      //   scenarios: true
      // };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"],
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf",
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null,
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    },
  },
};
</script>

<style scoped>
.table-controls {
  padding: 0 !important;
}
table.v-table td,
th {
  box-shadow: 1px 0px 0px 0px #eee;
}
table.v-table tbody tr {
  cursor: pointer !important;
}
.current-row {
  background-color: #ddd;
}
.row-active {
  box-shadow: 4px -1px 0px 0px rgb(76, 175, 80) inset;
}
.row-inactive {
  color: rgb(244, 67, 54);
  box-shadow: 4px 0px 0px 0px rgb(244, 67, 54) inset;
}
table.v-table td,
th {
  height: 30px !important;
  padding: 0px 5px 0px 5px !important;
}
table.v-table thead tr:not(.v-datatable__progress) {
  height: 30px;
}
table.v-table th {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.textRight {
  text-align: right;
}
.padding {
  padding: 7px;
}
.vline {
  border-right: 1px solid #eeeeee;
}
.border {
  border: 1px solid #e0e0e0;
}
</style>
